import { useEffect, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";

const toPng = (blob) => new Promise((res) => {
  const url = URL.createObjectURL(blob);
  const img = new Image();
  img.onload = () => {
    const c = document.createElement("canvas");
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    c.getContext("2d").drawImage(img, 0, 0);
    URL.revokeObjectURL(url);
    res(c.toDataURL("image/png"));
  };
  img.onerror = () => { URL.revokeObjectURL(url); res(null); };
  img.src = url;
});
const loadImg = (which) => api.get(`/signatures/${which}/image`, { responseType: "blob" }).then((r) => toPng(r.data)).catch(() => null);

export function useSignatures() {
  const { settings, isAdmin } = useApp();
  const s = settings?.signatures || {};
  const [imgs, setImgs] = useState({ prepared: null, concurred: null });
  useEffect(() => {
    let live = true;
    Promise.all([s.prepared_sig ? loadImg("prepared") : null, s.concurred_sig ? loadImg("concurred") : null])
      .then(([prepared, concurred]) => { if (live) { setImgs({ prepared, concurred }); } });
    return () => { live = false; };
  }, [s.prepared_sig, s.concurred_sig]);
  if (s.show === false || (!isAdmin && settings?.features?.signatures_church === false)) return null;
  const [y, m, d] = (s.sign_date || "").split("-").map(Number);
  const when = s.sign_date ? new Date(y, m - 1, d) : new Date();
  const date = s.show_date === false ? "" : when.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  return [
    { key: "prepared", label: "Prepared by", name: s.prepared_name || "", title: s.prepared_title || "", img: imgs.prepared, date },
    { key: "concurred", label: "Concurred by", name: s.concurred_name || "", title: s.concurred_title || "", img: imgs.concurred, date },
  ];
}
